<template>
  <div>
    <el-dialog class="weak_password_dialog" title="修改密码" :visible.sync="show" :close-on-click-modal="false" width="360px">
      <div class="clonse" @click="$emit('clonseWeakPassword', false)"
        v-if="roleEnName == 'student' || roleEnName == 'teacher'"></div>
      <div class="content">
        <div class="title">您的密码过于简单</div>
        <div class="text">为确保账号安全，请修改密码后重新登录</div>
        <div class="button_box" :class="{ 'flex_button_box': roleEnName != 'student' && roleEnName != 'teacher' }">
          <div class="button1" @click="$emit('operateChangePassword', '1')">立即修改密码</div>
          <div class="button2" @click="$emit('operateChangePassword', '2')"
            v-if="roleEnName == 'student' || roleEnName == 'teacher'">稍后修改</div>
          <!-- <div class="button2" @click="$emit('operateChangePassword','2')">稍后修改</div> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'WeakPassword',
  props: ['show', 'roleEnName'],
  watch: {
    show: {
      handler(newValue) {
        console.log(newValue);
      },
      immediate: true,
      deep: true
    },
  },
  data() {
    return {

    }
  },
  created() { },
  mounted() { },

  methods: {

  },
};
</script>

<style lang="scss" scoped>
.weak_password_dialog {

  //  width: 360px;
  .el-dialog {
    background-color: #fff;
    border-radius: 16px !important;
    min-height: 480px;
    background-image: url(../images/login/weak_password_bg.png);
    background-repeat: no-repeat;
    background-size: contain;
    margin-top: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 0 20px;
      position: relative;
      height: 100%;
      min-height: 480px;

      .clonse {
        height: 16px;
        width: 16px;
        cursor: pointer;
        position: absolute;
        top: 14px;
        right: 14px;
        background-image: url(../images/login/false.png);
        background-repeat: no-repeat;
        background-size: contain;
      }

      .content {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 220px;
        width: 100%;

        .title {
          font-size: 18px;
          font-weight: 500;
          text-align: center;
          color: #12151a;
          line-height: 28px;
          text-align: center;
        }

        .text {
          font-size: 14px;
          font-weight: 400;
          text-align: center;
          color: #959da6;
          line-height: 20px;
          margin-top: 8px;
        }

        .button_box {
          margin-top: 40px;
          height: 100px;

          .button1 {
            width: 296px;
            height: 44px;
            background: #409fff;
            border-radius: 8px;
            color: #fff;
            font-size: 14px;
            line-height: 44px;
            text-align: center;
            margin: 0 auto;
            cursor: pointer;
          }

          .button2 {
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            text-align: center;
            color: #959da6;
            line-height: 44px;
            margin: 12px 32px;
            cursor: pointer;
          }
        }

        .flex_button_box {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WeakPassword.vue